import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function SignatureQuestionIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 16 16'
    >
      <g id='Layer 2'>
        <g id='edit-2'>
          <path
            id='Vector'
            d='M12.6667 13.3333H3.33333C3.15652 13.3333 2.98695 13.4036 2.86193 13.5286C2.7369 13.6536 2.66666 13.8232 2.66666 14C2.66666 14.1768 2.7369 14.3464 2.86193 14.4714C2.98695 14.5964 3.15652 14.6667 3.33333 14.6667H12.6667C12.8435 14.6667 13.013 14.5964 13.1381 14.4714C13.2631 14.3464 13.3333 14.1768 13.3333 14C13.3333 13.8232 13.2631 13.6536 13.1381 13.5286C13.013 13.4036 12.8435 13.3333 12.6667 13.3333Z'
            fill='#3E8FFA'
          />
          <path
            id='Vector_2'
            d='M3.33333 12H3.39333L6.17333 11.7467C6.47786 11.7163 6.76269 11.5822 6.98 11.3667L12.98 5.36667C13.2129 5.12064 13.3387 4.79234 13.33 4.45369C13.3212 4.11504 13.1786 3.79367 12.9333 3.56L11.1067 1.73333C10.8683 1.5094 10.5559 1.38091 10.2289 1.3723C9.90191 1.3637 9.58319 1.47558 9.33333 1.68667L3.33333 7.68667C3.11784 7.90398 2.98367 8.1888 2.95333 8.49333L2.66667 11.2733C2.65769 11.371 2.67036 11.4694 2.70377 11.5616C2.73719 11.6538 2.79053 11.7375 2.86 11.8067C2.92229 11.8685 2.99617 11.9173 3.0774 11.9505C3.15862 11.9837 3.2456 12.0005 3.33333 12ZM10.18 2.66667L12 4.48667L10.6667 5.78667L8.88 4L10.18 2.66667ZM4.24667 8.60667L8 4.88L9.8 6.68L6.06667 10.4133L4.06667 10.6L4.24667 8.60667Z'
            fill='#3E8FFA'
          />
        </g>
      </g>
    </SvgIcon>
  );
}
